var originData = [
    {
        "Item": "Tensile Strength",
        "Test Way": "ASTM D638",
        "Test Conditions": "50mm/min",
        "Unit": "MPa",
        "ABS": 42,
        "ASA": 50,
        "Easy ABS": 36,
        "Easy PA": 75,
        "PCL": "/",
        "PETG": 61.4,
        "PLA": 61,
        "PLA Meta": 50,
        "PLA Marble": 61,
        "PLA WOOD": 48.6,
        "PLA+": 53.4,
        "PLA Carbon Fiber": 44.8,
        "Matte PLA": 50.5,
        "Glow in Dark PLA": 49,
        "PVA": 23,
        "PVB": 53.3,
        "TPU": 21.7,
        "High Speed PLA": 54.1,
        "TPU Silk": 21.4,
        "Silk PLA+": 60.6
    },
    {
        "Item": "Young's Modulus",
        "Test Way": "ASTM D638",
        "Test Conditions": "1mm/min",
        "Unit": "MPa",
        "ABS": 2270,
        "ASA": 2220,
        "Easy ABS": 2015,
        "Easy PA": 1790,
        "PCL": "/",
        "PETG": 2990,
        "PLA": 3500,
        "PLA Meta": 2000,
        "PLA Marble": 3500,
        "PLA WOOD": 3240,
        "PLA+": 3170,
        "PLA Carbon Fiber": 3530,
        "Matte PLA": 4780,
        "Glow in Dark PLA": "/",
        "PVA": "/",
        "PVB": "/",
        "TPU": 50.2,
        "High Speed PLA": 3282,
        "TPU Silk": 537,
        "Silk PLA+": 2760
    },
    {
        "Item": "Elongation at Break",
        "Test Way": "ASTM D638",
        "Test Conditions": "50mm/min",
        "Unit": "%",
        "ABS": 7.8,
        "ASA": 15,
        "Easy ABS": 20,
        "Easy PA": 32,
        "PCL": 800,
        "PETG": 5.3,
        "PLA": 3.1,
        "PLA Meta": 17,
        "PLA Marble": 3.1,
        "PLA WOOD": 8.1,
        "PLA+": 20.3,
        "PLA Carbon Fiber": 4.1,
        "Matte PLA": 9.6,
        "Glow in Dark PLA": 21,
        "PVA": 215,
        "PVB": 31.9,
        "TPU": 536,
        "High Speed PLA": 13.9,
        "TPU Silk": 436,
        "Silk PLA+": 6.3
    },
    {
        "Item": "Bending Strength",
        "Test Way": "ASTM D790",
        "Test Conditions": "2mm/min",
        "Unit": "MPa",
        "ABS": 55,
        "ASA": 73,
        "Easy ABS": 50,
        "Easy PA": 98,
        "PCL": "/",
        "PETG": 74.8,
        "PLA": 83,
        "PLA Meta": 72,
        "PLA Marble": 83,
        "PLA WOOD": 58,
        "PLA+": 81.8,
        "PLA Carbon Fiber": 64,
        "Matte PLA": 61,
        "Glow in Dark PLA": 79,
        "PVA": "/",
        "PVB": 63.3,
        "TPU": 4.26,
        "High Speed PLA": 75.2,
        "TPU Silk": 17.5,
        "Silk PLA+": 65
    },
    {
        "Item": "Flexural modulus",
        "Test Way": "ASTM D790",
        "Test Conditions": "2mm/min",
        "Unit": "MPa",
        "ABS": 1829,
        "ASA": 2114,
        "Easy ABS": 1681,
        "Easy PA": 2350,
        "PCL": "/",
        "PETG": 1686,
        "PLA": 2240,
        "PLA Meta": 2139,
        "PLA Marble": 2240,
        "PLA WOOD": 2212,
        "PLA+": 2740,
        "PLA Carbon Fiber": 2432,
        "Matte PLA": 2234,
        "Glow in Dark PLA": 2155,
        "PVA": "/",
        "PVB": 1651.9,
        "TPU": 87.6,
        "High Speed PLA": 2357,
        "TPU Silk": 617,
        "Silk PLA+": 1895
    },
    {
        "Item": "Notched Cantilever Beam Impact Strength",
        "Test Way": "ASTM D256",
        "Test Conditions": "3.2mm",
        "Unit": "J/m",
        "ABS": 126,
        "ASA": 18,
        "Easy ABS": 94,
        "Easy PA": 62,
        "PCL": "/",
        "PETG": 35,
        "PLA": 31,
        "PLA Meta": 48,
        "PLA Marble": 48,
        "PLA WOOD": 40,
        "PLA+": 19.8,
        "PLA Carbon Fiber": 32,
        "Matte PLA": 40,
        "Glow in Dark PLA": 31,
        "PVA": "/",
        "PVB": 4.5,
        "TPU": "Non-failure",
        "High Speed PLA": 5.9,
        "TPU Silk": 756,
        "Silk PLA+": 33
    },
    {
        "Item": "HDT - The temperature at which a polymer deforms under load.",
        "Test Way": "ASTM D648",
        "Test Conditions": "0.45MPa",
        "Unit": "℃",
        "ABS": 84,
        "ASA": 96,
        "Easy ABS": 57.9,
        "Easy PA": 121,
        "PCL": "/",
        "PETG": 63,
        "PLA": 53,
        "PLA Meta": 53,
        "PLA Marble": 53,
        "PLA WOOD": 53,
        "PLA+": 53.8,
        "PLA Carbon Fiber": 53,
        "Matte PLA": 53,
        "Glow in Dark PLA": 53,
        "PVA": 55,
        "PVB": 53,
        "TPU": 52,
        "High Speed PLA": 57.3,
        "TPU Silk": 131,
        "Silk PLA+": 53
    },
    {
        "Item": "Dry Before Printing",
        "Test Way": "/",
        "Test Conditions": "/",
        "Unit": "/",
        "ABS": "No",
        "ASA": "No",
        "Easy ABS": "No",
        "Easy PA": "Yes",
        "PCL": "No",
        "PETG": "No",
        "PLA": "No",
        "PLA Meta": "No",
        "PLA Marble": "No",
        "PLA WOOD": "No",
        "PLA+": "No",
        "PLA Carbon Fiber": "No",
        "Matte PLA": "No",
        "Glow in Dark PLA": "No",
        "PVA": "No",
        "PVB": "No",
        "TPU": "No",
        "High Speed PLA": "No",
        "TPU Silk": "No",
        "Silk PLA+": "No"
    },
    {
        "Item": "Drying Condition",
        "Test Way": "/",
        "Test Conditions": "/",
        "Unit": "/",
        "ABS": "50℃-4h",
        "ASA": "50℃-4h",
        "Easy ABS": "50℃-4h",
        "Easy PA": "80-110℃-6h",
        "PCL": "/",
        "PETG": "50℃-4h",
        "PLA": "50℃-4h",
        "PLA Meta": "50℃-4h",
        "PLA Marble": "50℃-4h",
        "PLA WOOD": "50℃-4h",
        "PLA+": "50℃-4h",
        "PLA Carbon Fiber": "50℃-4h",
        "Matte PLA": "50℃-4h",
        "Glow in Dark PLA": "50℃-4h",
        "PVA": "/",
        "PVB": "50℃-4h",
        "TPU": "70-80℃-4h",
        "High Speed PLA": "50℃-4h",
        "TPU Silk": "50℃-4h",
        "Silk PLA+": "50℃-4h"
    },
    {
        "Item": "Build Plate& Bed Temperature",
        "Test Way": "/",
        "Test Conditions": "/",
        "Unit": "/",
        "ABS": "Engineering Plate\n80-100℃",
        "ASA": "PEI Plate/High Temperature Plate\n90-110℃",
        "Easy ABS": "PEI Plate/High Temperature Plate\n60-70℃",
        "Easy PA": "Engineering Plate\n30-50℃",
        "PCL": "/",
        "PETG": "PEI Plate/High Temperature Plate\n60-70℃",
        "PLA": "Cool Plate/PLA Plate\n50-60℃",
        "PLA Meta": "Cool Plate/PLA Plate\n50-60℃",
        "PLA Marble": "Cool Plate/PLA Plate\n50-60℃",
        "PLA WOOD": "Cool Plate/PLA Plate\n50-60℃",
        "PLA+": "Cool Plate/PLA Plate\n50-60℃",
        "PLA Carbon Fiber": "Cool Plate/PLA Plate\n50-60℃",
        "Matte PLA": "Cool Plate/PLA Plate\n50-60℃",
        "Glow in Dark PLA": "Cool Plate/PLA Plate\n50-60℃",
        "PVA": "Cool Plate/PLA Plate\n50-60℃",
        "PVB": "Cool Plate/PLA Plate\n50-60℃",
        "TPU": "Cool Plate/PLA Plate\n50-60℃",
        "High Speed PLA": "Cool Plate/PLA Plate\n50-60℃",
        "TPU Silk": "Cool Plate/PLA Plate\n50-60℃",
        "Silk PLA+": "Cool Plate/PLA Plate\n50-60℃"
    },
    {
        "Item": "Printing with Enclosure",
        "Test Way": "/",
        "Test Conditions": "/",
        "Unit": "/",
        "ABS": "Required",
        "ASA": "Not Required",
        "Easy ABS": "Not Required",
        "Easy PA": "Not Required",
        "PCL": "Not Required",
        "PETG": "Not Required",
        "PLA": "Not Required",
        "PLA Meta": "Not Required",
        "PLA Marble": "Not Required",
        "PLA WOOD": "Not Required",
        "PLA+": "Not Required",
        "PLA Carbon Fiber": "Not Required",
        "Matte PLA": "Not Required",
        "Glow in Dark PLA": "Not Required",
        "PVA": "Not Required",
        "PVB": "Not Required",
        "TPU": "Not Required",
        "High Speed PLA": "Not Required",
        "TPU Silk": "Not Required",
        "Silk PLA+": "Not Required"
    },
    {
        "Item": "Printing Speed",
        "Test Way": "/",
        "Test Conditions": "/",
        "Unit": "/",
        "ABS": "≤200mm/s",
        "ASA": "≤200mm/s",
        "Easy ABS": "≤200mm/s",
        "Easy PA": "≤200mm/s",
        "PCL": "/",
        "PETG": "50-200mm/s",
        "PLA": "50-200mm/s",
        "PLA Meta": "50-200mm/s",
        "PLA Marble": "50-150mm/s",
        "PLA WOOD": "50-200mm/s",
        "PLA+": "50-300mm/s",
        "PLA Carbon Fiber": "50-200mm/s",
        "Matte PLA": "50-230mm/s",
        "Glow in Dark PLA": "50-200mm/s",
        "PVA": "50-200mm/s",
        "PVB": "50-200mm/s",
        "TPU": "50-150mm/s",
        "High Speed PLA": "50-600mm/s",
        "TPU Silk": "50-200mm/s",
        "Silk PLA+": "50-200mm/s"
    },
    {
        "Item": "Nozzle Temperature",
        "Test Way": "/",
        "Test Conditions": "/",
        "Unit": "/",
        "ABS": "250-260℃",
        "ASA": "255-265℃",
        "Easy ABS": "225-235℃",
        "Easy PA": "255-265℃",
        "PCL": "75-85℃",
        "PETG": "230-240℃",
        "PLA": "200-210℃",
        "PLA Meta": "185-195℃",
        "PLA Marble": "210-220℃",
        "PLA WOOD": "205-215℃",
        "PLA+": "205-215℃",
        "PLA Carbon Fiber": "215-225℃",
        "Matte PLA": "205-215℃",
        "Glow in Dark PLA": "205-215℃",
        "PVA": "200-210℃",
        "PVB": "200-210℃",
        "TPU": "195-205℃",
        "High Speed PLA": "205-215℃",
        "TPU Silk": "210-220℃",
        "Silk PLA+": "205-215℃"
    },
    {
        "Item": "Cooling Fan Setting",
        "Test Way": "/",
        "Test Conditions": "/",
        "Unit": "/",
        "ABS": 1,
        "ASA": 1,
        "Easy ABS": 1,
        "Easy PA": 1,
        "PCL": "/",
        "PETG": 1,
        "PLA": 1,
        "PLA Meta": 1,
        "PLA Marble": 1,
        "PLA WOOD": 1,
        "PLA+": 1,
        "PLA Carbon Fiber": 1,
        "Matte PLA": 1,
        "Glow in Dark PLA": 1,
        "PVA": 1,
        "PVB": 1,
        "TPU": 0.7,
        "High Speed PLA": 1,
        "TPU Silk": 0.7,
        "Silk PLA+": 1
    },
    {
        "Item": "Application Scenarios",
        "Test Way": "/",
        "Test Conditions": "/",
        "Unit": "/",
        "ABS": "Industrial mechanical plastic components, model machinery, electronic appliances, instrumentation",
        "ASA": "Outdoor applications, construction industry, electronic product casings, amusement facilities, gardening supplies",
        "Easy ABS": "Industrial mechanical plastic components, model machinery, electronic appliances, instrumentation, and other industrial sectors.",
        "Easy PA": "Rapid Prototyping、Functional Part Manufacturing、Electronics Manufacturing",
        "PCL": "Medical Field、Prototyping and Education、Biodegradable Products、Cosmetic Products、3D Printed Art",
        "PETG": "Home Appliance Parts、Toys、Stationery Items、Electronics Accessories、Cosmetic Containers、",
        "PLA": "Prototyping、Model Making、Experimental Apparatuses、Science Exhibits、Arts and Crafts、Custom Products",
        "PLA Meta": "Daily accessories、Decorative objects、Toys、Sculptural pieces、Enclosures、COSPLAY",
        "PLA Marble": "Decorative and home accents/accessories、Artworks and sculptures、 Architectural models and landscape designs、Displays、 Cultural heritage preservation and restoration",
        "PLA WOOD": "Residential ornamental objects、Domestic furnishings and household articles、Artisanal products and mementos、Instructional and exhibitory applications、Cultural patrimony conservation and rehabilitation",
        "PLA+": "Mechanical equipment、 Electronic appliances、 Decorative components、Cosplay ",
        "PLA Carbon Fiber": " Functional component manufacturing、Sports equipment、Electronic product enclosures",
        "Matte PLA": "Daily accessories、Decorative objects、Toys、Sculptural pieces、Enclosures、COSPLAY",
        "Glow in Dark PLA": " Luminous decorative items、Luminous toys、Safety markings、Luminous decorative and artisanal objects、Luminous tool and equipment markings",
        "PVA": "Support structure, multi-material printing, model fabrication.",
        "PVB": "Optical components\nDecorations and art pieces\nBiomedical applications\nSustainable products",
        "TPU": "Insole materials, machinery, automotive, electronics, sporting goods",
        "High Speed PLA": "Prototype production, model making, experimental apparatus, scientific exhibits, Personalized/customized products.",
        "TPU Silk": "\nClothing and fashion design, home goods, sports equipment, medical and health field, art and creative design.",
        "Silk PLA+": "Daily accessories, decorations, toys, sculptures, enclousre, COSPLAY,"
    }
]